import { X } from 'lucide-react';
import { useState } from 'react';

import Image from 'next/image';

import { LightBoxModal } from '@widgets/LightBoxModal';

import cls from './Reviews.module.scss';

type ReviewImagesPreviewProps = {
  previewUrls: string[];
  onRemove: (index: number) => void;
};

export const ReviewImagesPreview = ({ previewUrls, onRemove }: ReviewImagesPreviewProps) => {
  const [currentImageUrl, setCurrentImageUrl] = useState('');

  if (!previewUrls.length) return null;

  const handleOpenLightBox = (url: string) => () => {
    setCurrentImageUrl(url);
  };

  const handleCloseLightBox = () => {
    setCurrentImageUrl('');
  };

  return (
    <>
      <div className={cls.previewImages}>
        {previewUrls.map((src, index) => (
          <div
            key={`${src}-${index}`}
            className={cls.previewImageWrap}
          >
            <button
              className={cls.previewImageButton}
              type={'button'}
              aria-label={`Открыть фотографию ${index + 1}`}
              onClick={handleOpenLightBox(src)}
            >
              <Image
                src={src}
                width={216}
                height={105}
                alt={`Фотография к отзыву ${index + 1}`}
                className={cls.previewImage}
                unoptimized
              />
              <div className={cls.previewImageOverlay} />
            </button>
            <button
              className={cls.removePreviewButton}
              type={'button'}
              aria-label={`Удалить фотографию ${index + 1}`}
              onClick={() => onRemove(index)}
            >
              <X
                width={18}
                height={18}
              />
            </button>
          </div>
        ))}
      </div>

      {currentImageUrl && (
        <LightBoxModal
          open={Boolean(currentImageUrl)}
          imageUrls={previewUrls}
          currentImageUrl={currentImageUrl}
          onClose={handleCloseLightBox}
        />
      )}
    </>
  );
};
